// Threshold time after which we can insert duplicate elements in the cache
var CACHE_DEDUPLICATION_THRESHOLD_MILLISECONDS = 1000 * 60 * 10; // 10 minutes

var CACHE_SIZE_KILOBYTES = 4096;
var CACHE_MAX = 'max';
var CACHE_SIZE = 'cacheSize';
var CACHE_ENABLED = 'cacheEnabled';
var CACHE_DEDUPLICATION_TIME_MILLISECONDS = 'cacheDeduplicationTimeMilliseconds';
var LOGGER_URL = 'https://allstatecloud.sharepoint.com/sites/CompoZed_Engineering_PUB/SitePages/Logger.aspx';
var LOGGER_FACTORY_URL = 'https://allstatecloud.sharepoint.com/sites/CompoZed_Engineering_PUB/SitePages/LoggerFactory.aspx';
var LOGGER_EVENT_TYPE_URL = 'https://allstatecloud.sharepoint.com/sites/CompoZed_Engineering_PUB/SitePages/LoggingEventType.aspx';
var LOGGER_RESULT_TYPE_URL = 'https://allstatecloud.sharepoint.com/sites/CompoZed_Engineering_PUB/SitePages/LoggingEventType.aspx';
export { CACHE_DEDUPLICATION_THRESHOLD_MILLISECONDS, CACHE_SIZE_KILOBYTES, CACHE_MAX, CACHE_SIZE, CACHE_ENABLED, CACHE_DEDUPLICATION_TIME_MILLISECONDS, LOGGER_URL, LOGGER_FACTORY_URL, LOGGER_EVENT_TYPE_URL, LOGGER_RESULT_TYPE_URL };